<template>
  <div class="all_work_order_style">
    <div class="fixed_search" :style="searchHeight">
      <Form ref="formValidate" :model="formValidate" class="form_submit_style">
        <FormItem v-for="(item,index) in formValidate.searchList" :key="index">
          <Input v-if="(item.type=='text' || item.type=='textarea') && item.customColName != 'orderTheme'" :title="item.customName" :placeholder="item.customName" v-model="item.customValue"/>

          <Input v-if="item.customColName == 'orderTheme'" :title="item.customName+',工单编号'" :placeholder="item.customName+',工单编号'" v-model="item.customValue"/>

          <el-date-picker  v-model="item.customValue" unlink-panels type="datetimerange" :start-placeholder="'开始'+item.customName" :end-placeholder="'结束'+item.customName"  :title="item.customName" align="left" :default-time="['00:00:00', '23:59:59']"
                           :editable="editable" :picker-options="item.customColName=='nextConnectTime'?pickerOptionsAndFuture:pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss" v-if="item.type=='datetime'"></el-date-picker>

          <Select v-if="(item.type=='select' || item.type=='radio') && (item.customColName != 'copyEmpId' && item.customColName != 'orderHandler')" filterable :max-tag-count="2" clearable multiple class="multiple_search" :placeholder="item.customName" :title="item.customName" clearable  v-model="item.customValue" >
            <Option v-for="(option, index) in item.list" :value="option.id" :key="option.id">{{option.dictValue}}</Option>
          </Select>

          <Select v-if="item.type=='checkbox' && (item.customColName != 'copyEmpId' && item.customColName != 'orderHandler')" :placeholder="item.customName" filterable class="multiple_search" :title="item.customName" clearable multiple :max-tag-count="1" v-model="item.customValue">
            <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}</Option>
          </Select>

          <Select v-if="item.customColName == 'copyEmpId' || item.customColName == 'orderHandler'" filterable :placeholder="item.customName" :title="item.customName" clearable multiple class="multiple_search"  :max-tag-count="1" v-model="item.customValue">
                <OptionGroup label="员工">
                  <Option v-for="(option, index) in item.list[0].list" :value="option.id" :key="index">{{option.dictValue}}</Option>
                </OptionGroup >
                <OptionGroup label="服务组">
                  <Option v-for="(option, index) in item.list[0].orderGroupList" :value="option.id" :key="index">{{option.dictValue}}</Option>
                </OptionGroup >
          </Select>

          <el-cascader clearable  v-if="item.type=='cascade'" v-model="item.customValue" :placeholder="item.customName" :title="item.customName" :options="item.list" :props="{ expandTrigger: 'hover' }"></el-cascader>

          <Input v-if="item.type=='number'" type="number" placeholder="只能输入数字" :title="item.customName" v-model="item.customValue"/>
        </FormItem>
        <FormItem class="fixed_operation_btn senior_search">
          <el-popover  placement="bottom" width="400" trigger="click" v-if="formValidate.seniorList.length>0" :visible-arrow="visible">
            <div v-for="(item,index) in formValidate.seniorList" :key="index">
              <Input v-if="(item.type=='text' || item.type=='textarea') && item.customColName != 'orderTheme'" :title="item.customName" :placeholder="item.customName" v-model="item.customValue"/>

              <Input v-if="item.customColName == 'orderTheme'" :title="item.customName+',工单编号'" :placeholder="item.customName+',工单编号'" v-model="item.customValue"/>

              <el-date-picker  v-model="item.customValue" unlink-panels type="datetimerange" :start-placeholder="'开始'+item.customName" :end-placeholder="'结束'+item.customName"  :title="item.customName" align="left" :default-time="['00:00:00', '23:59:59']"
                               :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss" v-if="item.type=='datetime'"></el-date-picker>

              <Select v-if="(item.type=='select' || item.type=='radio')&& (item.customColName != 'copyEmpId' && item.customColName != 'orderHandler')" filterable :placeholder="item.customName" multiple :title="item.customName" clearable  v-model="item.customValue">
                <Option v-for="(option, index) in item.list" :value="option.id" :key="option.id">{{option.dictValue}}</Option>
              </Select>

              <el-cascader clearable  v-if="item.type=='cascade'" v-model="item.customValue" :placeholder="item.customName" :title="item.customName" :options="item.list" :props="{ expandTrigger: 'hover' }"></el-cascader>

              <Select v-if="item.type=='checkbox' && (item.customColName != 'copyEmpId' && item.customColName != 'orderHandler')" filterable class="multiple_style" :placeholder="item.customName" :title="item.customName" clearable multiple  :max-tag-count="1" v-model="item.customValue">
                <Option v-for="(option, index) in item.list" :value="option.id" :key="index">{{option.dictValue}}</Option>
              </Select>

              <Select v-if="item.customColName == 'copyEmpId' || item.customColName == 'orderHandler'" filterable class="multiple_style" :placeholder="item.customName" :title="item.customName" clearable multiple  :max-tag-count="1" v-model="item.customValue">
                <OptionGroup label="员工">
                  <Option v-for="(option, index) in item.list[0].list" :value="option.id" :key="index">{{option.dictValue}}</Option>
                </OptionGroup >
                <OptionGroup label="服务组">
                  <Option v-for="(option, index) in item.list[0].orderGroupList" :value="option.id" :key="index">{{option.dictValue}}</Option>
                </OptionGroup >
              </Select>

              <Input v-if="item.type=='number'" type="number" placeholder="只能输入数字" :title="item.customName" v-model="item.customValue"/>
            </div>
            <el-button slot="reference"><div class="btn_font_search">高级搜索</div></el-button>
          </el-popover>
          <Button type="primary" class="search_btn"  @click="initSearch()" style="margin-left: 10px">查询</Button>
          <Button type="primary" style="margin-left: 10px" class="search_btn reset_btn"  @click="orderReset()">重置</Button>
        </FormItem>
      </Form>
    </div>
    <div class="public_btn" v-if="showPublicBtn">
      <Button class="search_btn template_btn" v-if="orderCode == 'b_2' && roleList['b_2-1']" @click="addWorkOrder('','')">新建工单</Button>
      <Button class="search_btn template_btn" @click="exportOrder(orderCode)" v-if="showExportBtn">导出</Button>
      <Button class="search_btn template_btn" @click="batchOperate(orderCode)" v-if="showBatchDeleteBtn">批量删除</Button>

      <Button class="search_btn template_btn" @click="batchDelete()"
      v-if="orderCode == 'b_d' && roleList['b_d-4']">批量删除</Button>
      <Button class="search_btn template_btn" @click="batchOperate('b_d-3')"
      v-if="orderCode == 'b_d' && roleList['b_d-3']">批量还原</Button>

    </div>
    <div class="fixed_table flexmytable">
      <Spin size="large" fix v-if="spinShow"> <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <el-table :data="contentList" style="width: 100%" :height="tableHeight" class="element_table" stripe ref="selection" :class="{'tableClass':tableClass}" @sort-change="sortChange"  @cell-click="openCallScreen" :cell-class-name="returnClassName"  @selection-change="getSelectedId">
        <el-table-column type="selection" width="50" align="center"> </el-table-column>
        <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :key="item.key" :fixed="item.fixed" sortable="custom" :index="index" :prop="item.key" :label="item.title" :width="item.width">
          <!-- 头数据 -->
          <template slot="header" slot-scope="scope">
            <el-tooltip  placement="top">
              <span>{{item.title}}</span>
              <div slot="content" >
                <span>{{item.title}}</span>
              </div>
            </el-tooltip>
          </template>
          <template slot-scope="scope" >
            <!-- 附件 -->
            <el-tooltip placement="top" effect="light" v-if="item.customColSource != undefined && item.customColSource.indexOf('file') != -1 && scope.row[item.key] != '' && scope.row[item.key] != undefined" >
              <span style="color: #2d8cf0;" v-show="JSON.parse(scope.row[item.key]).length!=0">共{{JSON.parse(scope.row[item.key]).length}}个附件</span>
              <div slot="content">
                <p v-for="(fileItem,fileIndex) in JSON.parse(scope.row[item.key])" :key="fileIndex">
                  <a style="font-size:14px;" :href="baseURL+'common/downloadFile.json?type=0&addr='+fileItem.downloadAddr">附件{{fileIndex+1}}：{{fileItem.description}}</a>
                </p>
              </div>
            </el-tooltip>

            <span v-else-if="item.customColSource == 'id'">#{{scope.row[item.key]}}</span>
            <span v-else-if="item.customColSource == 'order_describe'">{{replaceEmoji(scope.row[item.key])}}</span>
            <!-- 工单状态 -->
            <div v-else-if="item.customColSource == 'order_state'" style="display:flex;align-items: center;margin-left: 10px;">
                <p :style="{'background-color':scope.row.dictDescr ? JSON.parse(scope.row.dictDescr).color : '','width':'15px','height':'15px','line-height':'16px','text-align':'center','color': 'white'}"
                    >{{scope.row.dictDescr ? JSON.parse(scope.row.dictDescr).shortValue : ''}}</p>
                <p :style="{'color':scope.row.dictDescr ? JSON.parse(scope.row.dictDescr).color : '','margin-right':'10px','margin-left':'5px','font-size': '14px','width': '65%','text-overflow': 'ellipsis',
    'overflow': 'hidden'}" >{{scope.row[item.key]}}</p>
            </div>

            <!-- 其他 -->
            <span v-else >{{scope.row[item.key]}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180" v-if="contentList.length>0" align="center">
          <template slot-scope="scope">
            <el-button @click="addWorkOrder(scope.row.id,scope.row.orderTheme)" type="text" size="small"
            v-if="showDetailBtn">详情</el-button>
            <el-button @click="restoreOrder(scope.row.id)" type="text" size="small"
            v-if="roleList['b_d-1'] && orderCode == 'b_d'">还原</el-button>
            <el-button @click="deleteOrder(orderCode,scope.row.id)" type="text" size="small"
            v-if="showDeleteBtn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent"  @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
    </div>
    <PublicSendMessage  @closeSendMessage="closeSendMessage" :showSendMessage="showSendMessage"  :callUpPhone="callUpPhone"></PublicSendMessage>
    <OrderOperatePop @closeOrderPop="closeOrderPop" :showTitlePop="showTitlePop" :menuCode="orderCode"></OrderOperatePop>
    <ExportOrderPop @closeExportOrderPop="closeExportOrderPop" :showExportPop="showExportPop" :menuCode="orderCode" ></ExportOrderPop>
    <OrderDeletePop @closeOrderDeletePop="closeOrderDeletePop" :showDeletePop="showDeletePop" :menuCode="orderCode" :deleteId="deleteId" ></OrderDeletePop>
    <RecycleOrderDeletePop @closeRecycleOrderDeletePop="closeRecycleOrderDeletePop" :showRecycleDeletePop="showRecycleDeletePop" ></RecycleOrderDeletePop>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  import {workOrderPublicBtn} from '@/components/js/WorkOrderPublicBtn.js'
  import publicDialerPage from '@/components/login/PublicDialerPage.vue'
  import OrderOperatePop from '@/components/workOrder/OrderOperatePop.vue'
  import ExportOrderPop from '@/components/systemSetup/worknote/ExportOrderPop.vue'
  import OrderDeletePop from '@/components/workOrder/OrderDeletePop.vue'
  import RecycleOrderDeletePop from '@/components/workOrder/RecycleOrderDeletePop.vue'
  import PublicSendMessage from '@/components/login/PublicSendMessage.vue'
  export default {
    name: "AllWorkOrders",
    mixins:[publicFunClass,workOrderPublicBtn],
    props:{
      pageCode:String,
      orderCode:String,
    },
    components:{
      publicDialerPage,
      OrderOperatePop,
      ExportOrderPop,
      OrderDeletePop,
      RecycleOrderDeletePop,
      PublicSendMessage
    },
    data(){
      return {
        showPageCount:0,
        formValidate:{"searchList":[],"seniorList":[],"allColumnInfo":[]},
        searchId: '',
        allColumnList:[],
        clientHeight:600,
        searchHeight:{'height':''},
        trajectoryId:'',
        customerName:'',
        myColor: true,
        spinShow: true,
        tableClass: true,
        showTitlePop: false,
        showImportPop: false,
        editable:false,
        visible: true,
        showExcelExport: false,
        showPublicPop: false,
        exportSign:'customer',
        showPage: false,
        customerType:'',
        sign:'0',
        popSign:'解除客户分配',
        pubTitle:'',
        wholeColor: false,
        showPublicBtn: true,
        tableHeight:600,
        judgeList: [{'id': '0', 'name': '是'}, {'id': '1', 'name': '否'}],
        judge: '-1',
        checkedAll: false,
        total: 0,
        uploadSign: "0",
        pageSizeList: [10, 20, 30, 40, 50, 100, 200],
        currentPage: 1,
        speedChangePage: 1,
        pageSize: 20,
        roleList: JSON.parse(localStorage.getItem("roleList")),
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        agentInfo: JSON.parse(localStorage.getItem("agentInfo")),
        singleCheckedList: [],
        fieldList: [],
        contentList: [],
        checkIds:[],
        currentColName:'',
        journalType:'',
        menuId:'',
        tableCount:0,
        orderIsSystem:'',
        orderField:'',
        orderRule:'',
        showInsertPop:false,
        deleteTitle:'',
        publicTitle:'导出客户',
        groupList:[],
        emojiList: require('@/assets/emotion.json'),

        initParam:{},
        menuCode:'', //菜单的id
        showExportPop: false,
        showDeletePop: false,
        showRecycleDeletePop: false,
        deleteId:-1,
        showExportBtn:false,
        showBatchDeleteBtn :false,
        showDetailBtn: false,
        showDeleteBtn: false,
        queryParam: null,
      }
    },
    methods:{
      htmlToString:function (sHtml) {
        return sHtml.replace(/[<>&"]/g,function(c){return {'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;'}[c];});
      },
      // 表情替换
      replaceEmoji(lastMsg){
        if(lastMsg && lastMsg.indexOf('/:') > -1){
          for(let i = 0; i < this.emojiList.length; i++){
            for(let n = 0; n < this.emojiList[i].length; n++){
              let newChar = this.htmlToString(this.emojiList[i][n].chars);
              lastMsg = lastMsg.replace(new RegExp(RegExp.escape(newChar),'g'),"");
            }
          }
        }
        return lastMsg;
      },
      // 新建工单
      addWorkOrder:function(id,tittle){
        let code = "b_w_1"+Math.random();
        let flag = "";
        if("b_2" == this.orderCode){  //所有工单
          flag = "b_2-5-";
        }else if("b_3" == this.orderCode){  //我的未完成工单
          flag = "b_3-3-";
        }else if("b_4" == this.orderCode){  //待我确认的工单
          flag = "b_4-4-";
        }else if("b_5" == this.orderCode){  //抄送给我的工单
          flag = "b_5-3-";
        }else if("b_6" == this.orderCode){  //我创建的工单
          flag = "b_6-3-";
        }else if("b_7" == this.orderCode){  //未分配的工单
          flag = "b_7-5-";
        }else if("b_8" == this.orderCode){  //已分配的工单
          flag = "b_8-4-";
        }else if("b_9" == this.orderCode){  //处理中的工单
          flag = "b_9-5-";
        }else if("b_a" == this.orderCode){  //暂停的工单
          flag = "b_a-3-";
        }else if("b_b" == this.orderCode){  //已完成的工单
          flag = "b_b-5-";
        }else if("b_c" == this.orderCode){  //已关闭的工单
          flag = "b_c-3-";
        }else if("b_d" == this.orderCode){  //回收站
          flag = "b_d-5-";
        }
        let that = this;
        setTimeout(function () {
          if(id){
            tittle = tittle.replace(/<[^>]+>/g, "");
            if (tittle && tittle.length > 5) {
              tittle = tittle.substring(0, 5) + "…";
            }
            code = "b_w_1-"+id;
            that.$emit("showStandardPage",code+","+tittle+","+flag,[]);
          }else{
            that.$emit("showStandardPage",code+",新建工单,"+flag,[]);
          }
          let param = {
            pageUuId:code,
          };
          let newGroupList = [];
          newGroupList.push(param)
          that.$store.commit('addWorkOrderReserve',newGroupList);
        },500);
      },
      openTel:function (row, column) {
        this.showServiceDetail=false;
        this.openCallScreen(row, column);
      },
      //设备信息当前页改变
      changeCurrent(event) {
        this.currentPage=event;
        this.initSearch();
      },
      //设备信息页面显示数量改变
      changeSize(event) {
        this.currentPage=1;
        this.pageSize=event;
        this.initSearch();
      },
      handleSearch:function () {
        this.orderReset();
        this.initSearch();
      },
      sortChange:function(event){
        if(event && event.order){
          let index=event.column.index;
          let obj=this.fieldList[index];
          this.orderIsSystem=obj.customIsSystem;
          this.orderField=obj.customColSource;
          this.orderRule=event.order=="descending"?"desc":"asc";
        }else{
          this.orderIsSystem="";
          this.orderField="";
          this.orderRule="";
        }
        this.initSearch();
      },
      initSearch:function () {
        // this.contentList.length = 0;
        this.$set(this.initParam, 'orderIsSystem', this.orderIsSystem);
        this.$set(this.initParam, 'orderField', this.orderField);
        this.$set(this.initParam, 'orderRule', this.orderRule);
        this.$set(this.initParam, 'pageNum', this.currentPage);
        this.$set(this.initParam, 'pageSize', this.pageSize);
        this.$set(this.initParam, 'journalType',"null");
        this.$set(this.initParam, 'menuId',"null");


        this.speedChangePage=this.currentPage;
        this.getParam(this.formValidate,this.initParam);
        let that=this;
        let phoneIsHide= this.configInfo.phoneIsHide;
        let phoneOwnership= this.configInfo.phoneOwnership;
        this.spinShow=true;
        // 查询条件
        this.queryParam = this.initParam;

        this.$http.post("workOrder/toIndex.json",this.initParam) .then(function (res) {
          let result=res.data.flag;
          that.spinShow=false;
          if(result!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.contentList=res.data.obj.list.content;

          that.groupList = [];
          that.groupList = res.data.obj.groupList;

          that.fieldList = [];
          let fieldList=res.data.obj.fields;

          let count=0;
          for (let j=0;j<fieldList.length;j++) {
            let customIsShow=fieldList[j].customIsShow;
            if(customIsShow=='1'){
              count++;
            }
          }
          that.tableCount=count;
          that.checkIds=[];
          let paramList=[];
          let seniorList=[];
          let allColumnInfo=[];
          let countFix=1;
          that.total=res.data.obj.list.totalSize;
          for (let i=0;i<fieldList.length;i++){
            let customColName=fieldList[i].customColName;
            if(customColName == 'orderState' && (that.orderCode == 'b_7' || that.orderCode == 'b_8' || that.orderCode == 'b_9' || that.orderCode == 'b_a' || that.orderCode == 'b_b' || that.orderCode == 'b_c' || that.orderCode == 'b_d')){
              continue;
            }
            if(customColName == 'creator' && that.orderCode == 'b_6'){
              continue;
            }
            let customIsSearch=fieldList[i].customIsSearch;
            let customIsSystem=fieldList[i].customIsSystem;
            let customColSource=fieldList[i].customColSource;

            let customName=fieldList[i].customName;
            let customType=fieldList[i].customType;
            let customIsMust=fieldList[i].customIsMust;
            let customIsShow=fieldList[i].customIsShow;
            let customIsAlter=fieldList[i].customIsAlter;

            if(paramList.length>9 && customIsSearch=='1'){
              customIsSearch='2';
            }
            if(customColName=="customerId"){
              customColName="customerName";
            }
            if(customColName=="employeeId"){
              customColName="employeeName";
            }
            let tableHead={
              title: customName,
              key: customColName,
              customIsSystem:customIsSystem,
              customColSource:customColSource,
              height:40
            };

            if(count>9){
              tableHead["width"]="150";
              if(customIsShow=='1' && countFix<4){
                countFix++;
                tableHead["fixed"]=true
              }
            }
            if(customIsShow=='1'){
              if(customColName.indexOf("customerPhone")!=-1){
                if(phoneIsHide=='1'){
                  tableHead.key=customColName+"Hide";
                }
                that.fieldList.push(tableHead);
                if(phoneOwnership=='1'){
                  let tableHead1={
                    title: customName+"归属地",
                    key: customColName+"Address",
                    customIsSystem:customIsSystem,
                    customColSource:customColSource,
                    height:40
                  };
                  if(count>9){
                    tableHead1["width"]="150";
                    if(customIsShow=='1' && countFix<4){
                      countFix++;
                      tableHead1["fixed"]=true
                    }
                  }
                  that.fieldList.push(tableHead1);
                }
              }else {
                if(customColName == 'orderState' || customColName == 'orderLevel' || customColName == 'orderChannel' || customColName == 'orderLabel'|| customColName == 'orderType'){
                  tableHead["width"]="100";
                }else{
                  tableHead["width"]="150";
                }
                that.fieldList.push(tableHead);
              }
            }
            let columnParam={
              type: customType,
              customColName: customColName,
              customValue:customType=='cascade'?[]:'',
              popCustomValue:customType=='cascade'?[]:'',
              checkName:"customValue",
              customIsMust:customIsMust,
              customName:customName,
              customIsSearch:customIsSearch,
              customIsAlter:customIsAlter,
              customIsSystem:customIsSystem,
              customColSource:customColSource,
              list:fieldList[i].list,
            };
            allColumnInfo.push(columnParam);
            if(customIsSearch=='1'){
              if(customColName=="orderState"){
                // 未分配的工单、已分配的工单、处理中的工单、暂停的工单、已完成的工单、已关闭的工单、回收站 不显示状态查询条件
                if(that.pageCode != 'b_7' && that.pageCode != 'b_8' && that.pageCode != 'b_9' && that.pageCode != 'b_a' && that.pageCode != 'b_b' && that.pageCode != 'b_c' && that.pageCode != 'b_d'){
                  paramList.push(columnParam);
                }
              }else if(customColName=="creator"){
                // 我创建的工单，不显示创建人
                if(that.pageCode != 'b_6'){
                  paramList.push(columnParam);
                }
              }else{
                paramList.push(columnParam);
              }
            }
            if(customIsSearch=='2'){
              seniorList.push(columnParam);
            }
          }
          //new 一个新的对象用于添加工单编号，写死
          let tableHead = {
            title: "工单编号",
            key: "id",
            customIsSystem:"1",
            customColSource:"id",
            height:40,
            width:100,
            fixed:true
          };
          that.fieldList.unshift(tableHead);
          // 当回收站时，新增删除原因
          if(that.orderCode == 'b_d'){
            let tableHeadReason = {
              title: "原因",
              key: "deleteReason",
              customIsSystem:"1",
              customColSource:"delete_reason",
              height:40,
              width:150,
              fixed:false
            };
            that.fieldList.push(tableHeadReason);

            let reason = {
              checkName:'customValue',
              customColName:'deleteReason',
              customColSource:'delete_reason',
              customIsAlter:'0',
              customIsMust:'0',
              customIsSearch:'1',
              customIsSystem:'0',
              customName:'原因',
              customValue:'',
              popCustomValue:'',
              type:'text',
              list:null,
            }
            paramList.push(reason);
          }
          let searchParam=that.formValidate.searchList;
          for (let i=0;i<paramList.length;i++){
            let colName=paramList[i].customColName;
            for (let j=0;j<searchParam.length;j++){
              let name=searchParam[j].customColName;
              if(colName==name){
                paramList[i].customValue=searchParam[j].customValue
              }
            }
          }

          let seniorParam=that.formValidate.seniorList;
          for (let m=0;m<seniorList.length;m++){
            let colName=seniorList[m].customColName;
            for (let n=0;n<seniorParam.length;n++){
              let name=seniorParam[n].customColName;
              if(colName==name){
                seniorList[m].customValue=seniorParam[n].customValue
              }
            }
          }
          that.formValidate.searchList=paramList;
          that.formValidate.seniorList=seniorList;
          that.formValidate.allColumnInfo=allColumnInfo;
          that.formValidate.fieldList=that.fieldList;
          let length=(paramList.length+2)>6?2:1;
          let height=length*40;
          that.searchHeight.height= height+"px";
          that.tableHeight=that.clientHeight-132-height;
          if (that.showPublicBtn) {
            that.tableHeight=that.clientHeight-182-height;
          }

          // 存入缓存中
          let cacheCustomer={
            formValidate:that.formValidate,
            contentList:that.contentList,
            pageNum:that.currentPage,
            pageSize:that.pageSize,
            total:that.total,
            queryParam: that.queryParam,
          };
          let cacheOrderList=JSON.parse(localStorage.getItem("cacheOrderList"));
          if(!cacheOrderList){
            cacheOrderList=[];
          }
          cacheOrderList[that.orderCode]=cacheCustomer;
          localStorage.setItem("cacheOrderList",JSON.stringify(cacheOrderList));

        });
      },
      getParam:function(formValidate,param,exportSign){
        // 将无关变量删除
        delete param["orderStateNotIn"];
        delete param["workOrderIncomplateView"];
        delete param["orderHandler"];
        delete param["isMyView"];
        delete param["orderState"];
        delete param["copyEmpAndGroup"];
        delete param["creator"];
        delete param["agentNumber"];

        let searchList=formValidate.searchList;
        let seniorList=formValidate.seniorList;
        let list=searchList.concat(seniorList);
        for (let i=0;i<list.length;i++){
          let customColName=list[i].customColName;
          if(customColName=="orderState" && (this.orderCode == 'b_4' || this.orderCode=='b_7' || this.orderCode=='b_8'|| this.orderCode=='b_9'|| this.orderCode=='b_a'|| this.orderCode=='b_b'|| this.orderCode=='b_c'|| this.orderCode=='b_d')){
            continue;
          }
          if(customColName=="creator" && this.orderCode == 'b_6'){
            continue;
          }

          if(customColName == 'customerName'){
            customColName = "customerId";
          }
          let customValue=list[i].customValue;
          if(customValue){
            customValue = customValue.toString();
          }

          let customType=list[i].type;
          param[customColName]=customValue;

          if (customType=="datetime") {
            param[customColName]="";
            if(customValue){
              param[customColName]=customValue.toString();
            }
          }
          if (customType=="cascade") {
            param[customColName]="";
            if(customValue.length>0){
              param[customColName]=customValue.toString();
            }
          }

        }

        if("b_2" == this.orderCode){  //所有工单
            param["orderStateNotIn"] = "-10";
          }else if("b_3" == this.orderCode){  //我的未完成工单
            param["workOrderIncomplateView"] = "1";
            param["orderHandler"] = this.agentInfo.employeeId;
            param["isMyView"] = "1";
          }else if("b_4" == this.orderCode){  //待我确认的工单
            param["orderState"] = "-15";
            param["orderHandler"] = this.agentInfo.employeeId;
            param["isMyView"] = "1";
          }else if("b_5" == this.orderCode){  //抄送给我的工单
            param["orderStateNotIn"] = "-10";
            param["copyEmpAndGroup"] = this.agentInfo.employeeId;
            param["isMyView"] = "1";
          }else if("b_6" == this.orderCode){  //我创建的工单
            param["orderStateNotIn"] = "-10";
            param["creator"] = this.agentInfo.employeeId;
            param["isMyView"] = "1";
            param["agentNumber"] = this.agentInfo.agentNumber;
          }else if("b_7" == this.orderCode){  //未分配的工单
            param["orderState"] = "-16";
          }else if("b_8" == this.orderCode){  //已分配的工单
            param["orderState"] = "-15";
          }else if("b_9" == this.orderCode){  //处理中的工单
            param["orderState"] = "-14";
          }else if("b_a" == this.orderCode){  //暂停的工单
            param["orderState"] = "-13";
          }else if("b_b" == this.orderCode){  //已完成的工单
            param["orderState"] = "-12";
          }else if("b_c" == this.orderCode){  //已关闭的工单
            param["orderState"] = "-11";
          }else if("b_d" == this.orderCode){  //回收站
           param["orderState"] = "-10";
          }
      },
      initRole:function(){
        switch(this.orderCode){
          case 'b_2':
            if(this.roleList['b_2-3']){
              this.showExportBtn = true;
            }else{
              this.showExportBtn = false;
            }
            if(this.roleList['b_2-4']){
              this.showBatchDeleteBtn = true;
            }else{
              this.showBatchDeleteBtn = false;
            }
            if(this.roleList['b_2-5']){
              this.showDetailBtn = true;
            }else{
              this.showDetailBtn = false;
            }
            if(this.roleList['b_2-6']){
              this.showDeleteBtn = true;
            }else{
              this.showDeleteBtn = false;
            }
            break;
          case 'b_3':
            if(this.roleList['b_3-1']){
              this.showExportBtn = true;
            }else{
              this.showExportBtn = false;
            }
            if(this.roleList['b_3-4']){
              this.showBatchDeleteBtn = true;
            }else{
              this.showBatchDeleteBtn = false;
            }
            if(this.roleList['b_3-3']){
              this.showDetailBtn = true;
            }else{
              this.showDetailBtn = false;
            }
            if(this.roleList['b_3-2']){
              this.showDeleteBtn = true;
            }else{
              this.showDeleteBtn = false;
            }
            break;
          case 'b_4':
            if(this.roleList['b_4-1']){
              this.showExportBtn = true;
            }else{
              this.showExportBtn = false;
            }
            if(this.roleList['b_4-5']){
              this.showBatchDeleteBtn = true;
            }else{
              this.showBatchDeleteBtn = false;
            }
            if(this.roleList['b_4-4']){
              this.showDetailBtn = true;
            }else{
              this.showDetailBtn = false;
            }
            if(this.roleList['b_4-2']){
              this.showDeleteBtn = true;
            }else{
              this.showDeleteBtn = false;
            }
            break;
          case 'b_5':
            if(this.roleList['b_5-1']){
              this.showExportBtn = true;
            }else{
              this.showExportBtn = false;
            }
            if(this.roleList['b_5-4']){
              this.showBatchDeleteBtn = true;
            }else{
              this.showBatchDeleteBtn = false;
            }
            if(this.roleList['b_5-3']){
              this.showDetailBtn = true;
            }else{
              this.showDetailBtn = false;
            }
            if(this.roleList['b_5-2']){
              this.showDeleteBtn = true;
            }else{
              this.showDeleteBtn = false;
            }
            break;
          case 'b_6':
            if(this.roleList['b_6-1']){
              this.showExportBtn = true;
            }else{
              this.showExportBtn = false;
            }
            if(this.roleList['b_6-4']){
              this.showBatchDeleteBtn = true;
            }else{
              this.showBatchDeleteBtn = false;
            }
            if(this.roleList['b_6-3']){
              this.showDetailBtn = true;
            }else{
              this.showDetailBtn = false;
            }
            if(this.roleList['b_6-2']){
              this.showDeleteBtn = true;
            }else{
              this.showDeleteBtn = false;
            }
            break;

          case 'b_7':
            if(this.roleList['b_7-1']){
              this.showExportBtn = true;
            }else{
              this.showExportBtn = false;
            }
            if(this.roleList['b_7-6']){
              this.showBatchDeleteBtn = true;
            }else{
              this.showBatchDeleteBtn = false;
            }
            if(this.roleList['b_7-5']){
              this.showDetailBtn = true;
            }else{
              this.showDetailBtn = false;
            }
            if(this.roleList['b_7-2']){
              this.showDeleteBtn = true;
            }else{
              this.showDeleteBtn = false;
            }
            break;
          case 'b_8':
            if(this.roleList['b_8-1']){
              this.showExportBtn = true;
            }else{
              this.showExportBtn = false;
            }
            if(this.roleList['b_8-5']){
              this.showBatchDeleteBtn = true;
            }else{
              this.showBatchDeleteBtn = false;
            }
            if(this.roleList['b_8-4']){
              this.showDetailBtn = true;
            }else{
              this.showDetailBtn = false;
            }
            if(this.roleList['b_8-2']){
              this.showDeleteBtn = true;
            }else{
              this.showDeleteBtn = false;
            }
            break;
          case 'b_9':
            if(this.roleList['b_9-1']){
              this.showExportBtn = true;
            }else{
              this.showExportBtn = false;
            }
            if(this.roleList['b_9-6']){
              this.showBatchDeleteBtn = true;
            }else{
              this.showBatchDeleteBtn = false;
            }
            if(this.roleList['b_9-5']){
              this.showDetailBtn = true;
            }else{
              this.showDetailBtn = false;
            }
            if(this.roleList['b_9-2']){
              this.showDeleteBtn = true;
            }else{
              this.showDeleteBtn = false;
            }
            break;
          case 'b_a':
            if(this.roleList['b_a-1']){
              this.showExportBtn = true;
            }else{
              this.showExportBtn = false;
            }
            if(this.roleList['b_a-4']){
              this.showBatchDeleteBtn = true;
            }else{
              this.showBatchDeleteBtn = false;
            }
            if(this.roleList['b_a-3']){
              this.showDetailBtn = true;
            }else{
              this.showDetailBtn = false;
            }
            if(this.roleList['b_a-2']){
              this.showDeleteBtn = true;
            }else{
              this.showDeleteBtn = false;
            }
            break;
          case 'b_b':
            if(this.roleList['b_b-1']){
              this.showExportBtn = true;
            }else{
              this.showExportBtn = false;
            }
            if(this.roleList['b_b-6']){
              this.showBatchDeleteBtn = true;
            }else{
              this.showBatchDeleteBtn = false;
            }
            if(this.roleList['b_b-5']){
              this.showDetailBtn = true;
            }else{
              this.showDetailBtn = false;
            }
            if(this.roleList['b_b-2']){
              this.showDeleteBtn = true;
            }else{
              this.showDeleteBtn = false;
            }
            break;
          case 'b_c':
            if(this.roleList['b_c-1']){
              this.showExportBtn = true;
            }else{
              this.showExportBtn = false;
            }
            if(this.roleList['b_c-4']){
              this.showBatchDeleteBtn = true;
            }else{
              this.showBatchDeleteBtn = false;
            }
            if(this.roleList['b_c-3']){
              this.showDetailBtn = true;
            }else{
              this.showDetailBtn = false;
            }
            if(this.roleList['b_c-2']){
              this.showDeleteBtn = true;
            }else{
              this.showDeleteBtn = false;
            }
            break;
          case 'b_d':
            if(this.roleList['b_d-5']){
              this.showExportBtn = true;
            }else{
              this.showExportBtn = false;
            }
            this.showBatchDeleteBtn = false;
            if(this.roleList['b_d-6']){
              this.showDetailBtn = true;
            }else{
              this.showDetailBtn = false;
            }
            if(this.roleList['b_d-2']){
              this.showDeleteBtn = true;
            }else{
              this.showDeleteBtn = false;
            }
            break;
        }
      }
    },
    created(){
      this.clientHeight=document.documentElement.clientHeight;
    },
    mounted(){
    },
    destroyed(){
      let cacheOrderList={};
      localStorage.setItem("cacheOrderList",JSON.stringify(cacheOrderList));
    },
    watch: {
      orderCode:function(){
        if(this.orderCode!="b_2" && this.orderCode!="b_3" && this.orderCode!="b_4" && this.orderCode!="b_5" && this.orderCode!="b_6"
         && this.orderCode!="b_7" && this.orderCode!="b_8" && this.orderCode!="b_9" && this.orderCode!="b_a" && this.orderCode!="b_b"
          && this.orderCode!="b_c" && this.orderCode!="b_d"){
          return false;
        }
        // 对权限进行更改
        this.initRole();
        let cacheOrderList=JSON.parse(localStorage.getItem("cacheOrderList"));

        if(!cacheOrderList){
          cacheOrderList=[];
        }
        if(this.menuCode != '' && this.menuCode != this.orderCode){
          let cacheOrder={
            formValidate:this.formValidate,
            contentList:this.contentList,
            pageNum:this.currentPage,
            pageSize:this.pageSize,
            total: this.total,
            queryParam: this.queryParam,
          };
          cacheOrderList[this.menuCode]=cacheOrder;
          localStorage.setItem("cacheOrderList",JSON.stringify(cacheOrderList));
        }

        this.menuCode = this.orderCode;
        let object=cacheOrderList[this.orderCode];
        if(object){
          this.formValidate=object.formValidate;
          this.contentList=object.contentList;
          this.fieldList = this.formValidate.fieldList;
          this.pageNum=object.currentPage;
          this.pageSize=object.pageSize;
          this.total=object.total;
          this.queryParam = object.queryParam;
          // this.$forceUpdate();
          return false;
        }

        this.orderReset();
        this.initSearch();
      },
      pageCode:function(){
        if(this.showPageCount == 0){
          this.showPageCount++;
          // this.initSearch();
        }

      },
    }
  }
</script>
<style>
.flexmytable .el-table th>.cell{
    overflow:hidden !important;
    text-overflow:ellipsis !important;
    white-space: nowrap !important;
  }
</style>
<style scoped>

 .all_work_order_style /deep/ ivu-tag ivu-tag-checked{
   height: 18px!important;
   line-height: 18px!important;
 }
 .all_work_order_style /deep/ ivu-icon ivu-icon-ios-close{
   top: 1px!important;
 }
 .all_work_order_style /deep/ .ivu-select-multiple .ivu-select-input {
   height: 22px !important;
   line-height: 22px !important;
 }
 .all_work_order_style /deep/ .ivu-select-multiple .ivu-tag{
   height: 18px!important;
   line-height: 18px!important;
 }
.el-popover .ivu-select{
    height: 35px;
    overflow: hidden;
    margin-bottom:13px;
}
</style>



// WEBPACK FOOTER //
// src/components/workOrder/AllWorkOrders.vue